import {SxProps} from "@mui/material";
import {BORDER_RADIUS_OUTER} from "../../../../config/themes/theme";

const STYLES = {
  promptInputContainer: {
    bgcolor: "secondary.light",
    borderRadius: BORDER_RADIUS_OUTER,
    p: 1,
  } as SxProps,
  textField: {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  } as SxProps,
  textFieldInput: {
    p: 0.75,
    pb: 1.5,
    fontSize: "1rem",
  } as SxProps,
  suggestionsButton: {
    borderRadius: BORDER_RADIUS_OUTER,
  } as SxProps,
  sendButton: {
    bgcolor: "primary.dark",
    borderRadius: "50%",
    "&:hover": {
      bgcolor: "primary.dark",
      opacity: 0.8,
    },
    "&.Mui-disabled": {
      bgcolor: "primary.main",
    },
  } as SxProps,
  disclaimerText: {
    color: "secondary.contrastText",
    textAlign: "center",
    width: "100%",
  } as SxProps,
  disclaimerContainer: {
    display: "flex",
    justifyContent: "center",
  } as SxProps,
};

export default STYLES;
